import type { FaireProductEntity } from "../../entity_types/product";

export const p_j7c8gbyy44: FaireProductEntity = {
  token: "p_j7c8gbyy44",
  type: "product",
  name: "Les Anis de Flavigny Pocket Case Rose .63oz",
  brandToken: "b_9anqzdvs32",
  brandName: "The French Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/c4ed2b1202e04664e635a2d3f13bd0e3be14d47b1da4f40d4fccc2da35ab0d69.png",
  galleryImageUrls: [],
  priceDollars: 2.06,
  description:
    "Delight in the delicate floral charm of Les Anis de Flavigny Rose sweets, petite anise-seed pastilles handcrafted in the village of Flavigny-sur-Ozerain in Burgundy, France. Each tiny candy begins with a single green anise seed at its center, gently coated in layers of sugar and natural rose flavor for a subtly sweet and fragrant bite.\n\nPackaged in a convenient 18 g pocket box, these classic French confections are perfect for on-the-go enjoyment or as a sweet, elegant treat anytime. Made with all-natural ingredients and no allergens, these rose-infused pastilles celebrate centuries of artisanal candy-making tradition.",
  tags: [],
  msrpDollars: 4.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:46.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
